<template>
  <v-navigation-drawer
    fixed
    style="margin-top: 65px"
    permanent
    @transitionend="onDrawerToggle"
    :style="{ width: drawerWidth + 'px', minWidth: minWidth + 'px' }"
    :class="mini ? 'mini' : ''"
    ref="drawer"
   
  >
    <div class="drawer-resizer"  >
      <div class="d-flex justify-center align-center ma-4">
        <div @click="handleMini">
          <v-icon v-if="mini === false">mdi-chevron-left</v-icon>
          <v-icon v-else>mdi-chevron-right</v-icon>
        </div>
        <h3
          class="text-center flex-grow-1"
          style="color: #384b6d; cursor: pointer"
          @click="goToPermissions"
          v-show="!mini"
        >
          Permisos
        </h3>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              @click.stop="openForm('add')"
              class="ml-auto"
              v-show="!mini"
              >mdi-plus</v-icon
            >
          </template>
          <span>{{ $tc("accessPermision.addPermission") }}</span>
        </v-tooltip>
      </div>
      <v-expansion-panels focusable v-show="!mini"  style="max-height: 80vh; overflow-y: auto;scrollbar-width:unset;"  >
        <v-expansion-panel
          v-for="(item, index) in schedules"
          :key="item.id"
          @click="goToSchedule(item)"
        >
          <v-expansion-panel-header
            expand-icon="mdi-menu-down"
             style="color: #384b6d; font-size: 18px;max-height: 100vh; overflow-y: auto;scrollbar-width:unset;"
          >
            <div style="max-width: 65%; word-wrap: break-word">
              {{ item.name }}
            </div>
            <v-row
              class="justify-end mx-2"
              style="width: 35%; white-space: nowrap"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <div class="center mr-1">
                      <v-icon
                        id="icon-edit"
                        @click.stop="openForm('edit', item)"
                      >
                        fas fa-pen
                      </v-icon>
                    </div>
                  </span>
                </template>
                <span>{{ $tc("commons.edit") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <div class="center">
                      <v-icon
                        id="icon-delete"
                        @click.stop="openForm('delete', item)"
                      >
                        fas fa-trash
                      </v-icon>
                    </div>
                  </span>
                </template>
                <span>{{ $tc("commons.delete") }}</span>
              </v-tooltip>
            </v-row>
            <template v-slot:actions>
              <v-icon color="primary" x-small class="ma-0"> $expand </v-icon>
            </template>
          </v-expansion-panel-header>

          <template v-slot:header>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon :color="selectedItem === index ? '#82a1d0' : ''"
                    >mdi-calendar</v-icon
                  >
                  <span
                    :class="{ 'selected-item': selectedItem === index }"
                    class="d-flex red"
                    >{{ item.name }}</span
                  >
                </span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </template>
          <v-expansion-panel-content>
            <v-list-item
              v-for="(subItem, i) in itemsSchedules"
              :key="i"
              link
              @click="subItem.function"
            >
              <v-list-item-icon>
                <v-icon style="color: #384b6d">{{ subItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title style="color: #384b6d">{{
                subItem.name
              }}</v-list-item-title>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-navigation-drawer>
</template>
<script>
import schedules from "@/store/permisosDeAcceso/accessPermissions";
import holidays from "@/store/permisosDeAcceso/holidays";
import groups from "@/store/permisosDeAcceso/groups";
import employeesPermissions from "@/store/permisosDeAcceso/employees";
import Loader from "@/components/Complement/Loader.vue";

export default {
  components: { Loader },
  props: {
    dataSchedule: Object,
  },

  data: () => ({
    segment: null,
    drawerWidth: 300,
    elements: null,
    selectedItem: null,
    idPermission: null,
    activeSchedules: [],
    openSchedules: {},
    isLoading: false,
    mini: false,
    tempDrawerWidth: null,
    minWidth: 300,
  }),
  mounted() {
    this.initializeDrawerResize();
  },

  computed: {
    schedules() {
      return schedules.state.permissions;
    },
    itemsSchedules() {
      return [
        { 
          name: "Segmentos",
          icon: "mdi-segment",
          function: this.goToSegment,
          children: [
          {
            name: "Elementos",
            icon: "mdi-hexagon-multiple",
            function: this.goToElementos
          },
          {
            name: "DFIS",
            icon: "mdi-vector-square",
            function: this.goToDFIS
          }
        ]
        },
        {
          name: "Empleados",
          icon: "mdi-badge-account",
          function: this.goToEmployee,
        },
        {
          name: "Grupos",
          icon: "mdi-account-group",
          function: this.goToGroups,
        },
        {
          name: "Grupo de Feriados",
          icon: "mdi-calendar-alert",
          function: this.goToHolidays,
        },
      ];
    },
  },

  methods: {
    handleMini() {
      this.mini = !this.mini;
      if (this.tempDrawerWidth !== null) {
        this.drawerWidth = this.tempDrawerWidth;
        this.tempDrawerWidth = null;
        this.minWidth = 300;
      } else {
        this.tempDrawerWidth = this.drawerWidth;
        this.drawerWidth = 60;
        this.minWidth = 60;
      }
    },
    onDrawerToggle(event) {
      if (this.minWidth <= this.drawerWidth) {
        if (this.minWidth === 60) {
          this.drawerWidth = 60;
          this.minWidth = 60;
        }
        const drawerWidth = parseInt(event.target.style.width);
        schedules.commit("setPaddingNav", drawerWidth.toString() + "px");
      } else {
        this.drawerWidth = 300;
      }
    },
    goToGroups() {
      this.isLoading = true;
      schedules.dispatch("handleShowWindow", "groups");
      groups.commit("setPermissionId", this.idPermission);
      groups.dispatch("getGroups").then(() => {
        this.isLoading = false;
      });
    },
    goToHolidays() {
      this.isLoading = true;
      schedules.dispatch("handleShowWindow", "holiday");
      holidays.commit("setPermissionId", this.idPermission);
      holidays.dispatch("getHolidaysId").then(() => {
        this.isLoading = false;
      });
    },
    goToEmployee() {
      this.isLoading = true;
      schedules.dispatch("handleShowWindow", "employees");
      employeesPermissions.commit("setPermissionId", this.idPermission);
      employeesPermissions.dispatch("getEmployees").then(() => {
        this.isLoading = false;
      });
    },
    goToPermissions() {
      this.isLoading = true;
      setTimeout(() => {  
        this.isLoading = false;
      }, 1000);
      schedules.dispatch("handleShowWindow", "assistent").then(() => {
        this.isLoading = false;
      });
    },

    goToSegment() {
      this.isLoading = true;
      schedules.dispatch("handleShowWindow", "segment");
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
      this.commitSegment(this.idPermission);
    },
    goToElementos() {
    this.isLoading = true;
    // Lógica para navegar a la vista de "Elementos"
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
    schedules.dispatch("handleShowWindow", "elementos");
  },
  goToDFIS() {
    this.isLoading = true;
    // Lógica para navegar a la vista de "DFIS"
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
    schedules.dispatch("handleShowWindow", "dfis");
  },
    goToSchedule(item) {
      this.idPermission = item.id;

      schedules.commit("setPermissionId", this.idPermission);
      schedules.dispatch("handleShowWindow", "schedule");
    },

    commitSegment(id) {
      schedules.commit("setPermissionId", id);
      schedules.dispatch("getSegments").then(() => {
        this.segment = schedules.state.segments;
      });
    },

    openForm(type, item) {
      let payload;
      switch (type) {
        case "add":
          payload = {
            type: "add",
            value: true,
          };
          schedules.commit("setMode", this.$tc("accessPermision.addPermission"));
          schedules.commit("setOpenSchedule", payload);
          break;
        case "edit":
          payload = {
            type: "edit",
            value: true,
          };
         
          this.dataSchedule.items[0].data = item.name;
          this.dataSchedule.items[1].data = item.requiredCacheo;
          if( item.requiredCacheo){
            this.dataSchedule.items[2].disabled = false;
            this.dataSchedule.items[2].data = item.porcentCacheo;
          }
          this.dataSchedule.items[3].data = item.requiredPin;
          this.dataSchedule.items[4].data = item.reqPassBack;
          this.dataSchedule.items[5].data = item.visit;
          this.dataSchedule.items[6].data = item.active;
 
          schedules.commit("setMode", this.$tc("accessPermision.editPermission"));
          schedules.commit("setOpenSchedule", payload);
          schedules.commit("setEditItemPermission", item.id);
          break;
        case "delete":
          schedules.commit("setOpenDeletePermission", true);
         
          schedules.commit("setItemDelete", item.id);

          break;
      }
    },
    initializeDrawerResize() {
      const drawer = this.$refs.drawer.$el;
      const resizer = drawer.querySelector(".drawer-resizer");

      let startX = 0;
      let initialWidth = 0;

      const handleMouseMove = (event) => {
        const diffX = event.clientX - startX;
        this.drawerWidth = initialWidth + diffX;
      };

      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      resizer.addEventListener("mousedown", (event) => {
        startX = event.clientX;
        initialWidth = drawer.offsetWidth;

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
      });
    },
  },
};
</script>
<style scoped>
.item-hover {
  padding-left: 0px !important;
}
.drawer-resizer {
  cursor: w-resize !important;
  min-height: 100%;
  margin-bottom: 64px;
}
.selected-item {
  font-weight: bold !important;
  color: #82a1d0 !important;
}
.mini {
  max-width: 60px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
  margin-left: 10px;
}
</style>
